import { CONSENT_COOKIE_KEY, CONSENT_VERSION, MASK_ANALYTICS, MASK_MARKETING, MASK_TECHNICAL } from './constants'
import { getCookieValue, setCookieValue, getCookieDomain } from '@shared/utils/cookie'
import { enableMetrika, metrikaHit } from './vendors/metrika'
import { enableRoistat } from './vendors/roistat'
import { enableTopMail } from './vendors/topmail'
import { getFingerprint } from '@shared/services/fingerpring'
import Vue from 'vue'

export class ConsentService {
  constructor(config) {
    this._config = config
    this._cache = null
  }

  getConsent() {
    if (this._cache) return this._cache

    const fromCookie = this._decodeConsent(getCookieValue(CONSENT_COOKIE_KEY))

    if (fromCookie && fromCookie.version === CONSENT_VERSION) {
      this._cache = fromCookie
    }

    return fromCookie
  }

  setConsent({ analytics, marketing, decided }) {
    const raw = this._encodeConsent({ analytics, marketing, decided })
    setCookieValue(CONSENT_COOKIE_KEY, raw, 365, { domain: getCookieDomain() })
    this._cache = this._decodeConsent(raw)
    return this._cache
  }

  async applyConsent(consent = this.getConsent()) {
    if (!this._config) {
      console.error('Cookie consent config not loaded')
      return
    }

    if (consent.analytics) {
      await Promise.allSettled([
        enableMetrika(this._config.metrikaId),
        enableRoistat({ host: this._config.roistatHost, projectId: this._config.roistatProjectId }),
      ])
    }

    if (consent.marketing) {
      await Promise.allSettled([enableTopMail(this._config.topMailId)])
    }
  }

  setAllConsent() {
    return this.setConsent({ analytics: true, marketing: true, decided: true })
  }

  trackPageView() {
    const consent = this.getConsent()
    if (!consent.analytics) return

    if (!this._config) {
      console.error('Cookie consent config not loaded')
      return
    }

    metrikaHit(this._config.metrikaId, location.href)
  }

  async sendLog() {
    try {
      const consent = this.getConsent()
      const fingerprint = await getFingerprint()

      /** Set-consent API method request **/
      await Vue.http.post('/api/services/set-consent', {
        consent,
        fingerprint,
      })
    } catch (e) {
      console.error('Send cookie log: ', e)
    }
  }

  _encodeConsent({ analytics, marketing, decided }) {
    let mask = MASK_TECHNICAL
    if (analytics) mask |= MASK_ANALYTICS
    if (marketing) mask |= MASK_MARKETING
    return `v${CONSENT_VERSION}:${mask}:${Number(decided)}`
  }

  _decodeConsent(raw) {
    if (!raw) return null
    const resOfMatching = raw.match(/^v(\d+):(\d+):(\d+)$/)
    if (!resOfMatching) return null

    const version = Number(resOfMatching[1])
    const mask = Number(resOfMatching[2])
    const decided = !!Number(resOfMatching[3])

    return {
      version,
      technical: true,
      analytics: true,
      marketing: (mask & MASK_MARKETING) === MASK_MARKETING,
      decided,
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/consent/consent.service.js